export default {
  fields: [
    {
      name: 'field-generic-input',
      width: '400px',
      title: 'Delivery',
      prop: 'name',
      sticky: false,
      id: 'name',
      alwaysVisible: true,
      isClickable: false,
      searchField: false,
      searchable: true,
    }, {
      name: 'shippingStatus',
      id: 'shippingStatus',
      title: 'Delivery Status',
      width: '146px',
      searchable: true,
      filterText: false,
      defaultVisible: true,
    }, {
      title: 'Ship By',
      name: 'shipBy',
      defaultVisible: true,
      prop: 'delivery.deliveryStart',
      kind: 'dates',
      width: '112px',
      id: 'shipBy',
      inputProps: {
        kind: '_delivery.deliveryStart',
        max: '_delivery.deliverBy',
        disableEdit() {
          return true;
        },
      },
    }, {
      title: 'Deliver By',
      name: 'deliverBy',
      defaultVisible: true,
      prop: 'delivery.deliverBy',
      kind: 'dates',
      width: '112px',
      id: 'deliverBy',
      inputProps: {
        kind: '_delivery.deliveryStart',
        max: '_delivery.deliverBy',
        disableEdit() {
          return true;
        },
      },
    },
]
}